<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Historial de entregas
            <router-link
              :to="{
                name: 'NuevoEntrega',
                params: {
                  config: {
                    page: page,
                    dates: selectedDate ,
                    cultivo: cultivo,
                    ubicacion: ubicacion,
                  }
                }
              }"
            >
              <CDropdown
                  class="my-2 c-dropdown"
                  color="primary"
                  square
                  :togglerText="'Registrar una entrega'"
                  :split="false"
                >
                  <CDropdownItem @click="tablaLabores = true">
                    <router-link
                      tag="li"
                      :to="{
                        name: 'NuevoEntrega',
                        params: { config: { page: page, dates: selectedDate } },
                      }"
                    >
                      Registrar una entrega
                    </router-link>
                  </CDropdownItem>
                  <CDropdownItem @click="tablaLabores = false">
                    <router-link
                      tag="li"
                      :to="{
                        name: 'NuevoEntregas',
                        params: { config: { page: page, dates: selectedDate } },
                      }"
                    >
                      Registrar varias entregas
                    </router-link>
                  </CDropdownItem>
                </CDropdown>

            </router-link>
          </CCardHeader>
          <CCardBody>
            <CRow class="d-flex flex-column flex-xl-row">
              <CCol md="3" lg="3" xl="3">
                <label class="d-block">Periodo:</label>
                <DateSelector
                  class="z-custom-2 mb-2"
                  v-model="selectedDate"
                  :date="selectedDate"
                  @input="dateSelection()"
                />
              </CCol>
            </CRow>

            <CDataTable
              hover
              bordered
              responsive
              :loading="isLoading"
              :items="this.items"
              :fields="headersTable"
              :items-per-page="Number(limit)"
              :noItemsView="noItems"
            >

              <template #over-table>
                <CRow class="align-items-center">
                  <CCol col="11">
                    <CRow class="d-flex flex-column flex-xl-row">
                      <CCol md="4" lg="4">
                        <label class="mt-2">Cultivo:</label>
                        <v-select
                          v-model="cultivo"
                          :options="cultivos"
                          @input="[limpiarVariedad(), filterLotes()]"
                          :loading="isLoadingInfo"
                          class="margin-multi"
                          placeholder="Selecciona un cultivo"
                        >
                          <template #open-indicator="{ attributes }">
                            <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                          </template>
                          <template #no-options>Sin resultados.</template>
                        </v-select>
                      </CCol>
                      <CCol md="4" lg="4">
                        <label class="mt-2">Variedad:</label>
                        <v-select
                          v-model="variedad"
                          :options="variedadesPorCultivo"
                          @input="filterLotes()"
                          :loading="isLoadingInfo"
                          class="margin-multi"
                          placeholder="Selecciona una variedad"
                        >
                          <template #open-indicator="{ attributes }">
                            <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                          </template>
                          <template #no-options>Sin resultados.</template>
                        </v-select>
                      </CCol>
                      <CCol md="4" lg="4">
                        <label class="mt-2">Ubicacion:</label>
                        <v-select
                          v-model="ubicacion"
                          :options="ubicaciones"
                          @input="filterLotes()"
                          :loading="isLoadingInfo"
                          class="margin-multi"
                          placeholder="Selecciona una ubicación"
                        >
                          <template #open-indicator="{ attributes }">
                            <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                          </template>
                          <template #no-options>Sin resultados.</template>
                        </v-select>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol class="p-0 mt-3" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-settings" />
                        </CButton>
                      </template>

                      <template #default>
                        <div class="p-3 d-flex flex-column w-100">
                          <div class="mb-1">
                            <span>
                              <strong>Ver</strong>
                            </span>
                          </div>
                          <hr class="line mt-1 mb-3" />
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Busqueda avanzada:</label>
                            <CSwitch :checked="advanceFilter" @update:checked="toggleAdvanceFilter()" class="mx-1" color="primary" variant="3d" />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Hora:</label>
                            <CSwitch
                              @update:checked="toggleHora()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Fecha de creación:</label>
                            <CSwitch
                              @update:checked="toggleCreatedAt()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Ubicaciones:</label>
                            <CSwitch
                              @update:checked="toggleUbicaciones()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Autor:</label>
                            <CSwitch @update:checked="toggleMostrarAutor()" class="mx-1" color="primary" variant="3d" />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Cancelados:</label>
                            <CSwitch
                              @update:checked="toggleShowCancel()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>

                        </div>
                      </template>
                    </CDropdown>
                  </CCol>
                  <CCol v-if="advanceFilter" sm="11" col="10">
                    <CRow class="advance-filter mb-4">



                      <CCol md="6" class="py-1">
                        <label class="d-block">Cantidad:</label>
                        <CRow>
                          <CCol><CInput type="number" :value.sync="$v.query.cantidad.start.$model" placeholder="De" class="mb-0 align-self-center" :isValid="query_cantidad_start" /></CCol>
                          <CCol><CInput type="number" :value.sync="$v.query.cantidad.end.$model" placeholder="Al" class="mb-0 align-self-center"  :isValid="query_cantidad_end" /></CCol>
                        </CRow>
                      </CCol>

                      <CCol md="6" class="py-1">
                        <label class="d-block">Comentarios:</label>
                        <CInput v-model="query.comentarios" placeholder="Comentarios" class="mb-0 align-self-center" />
                      </CCol>
                      <CCol col="10" class="pt-3">
                        <CButton @click="validForm" color="primary"> Buscar</CButton>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol v-else sm="11" col="10">
                    <CInput v-model="filter" @input="searchTimeOut()" placeholder="Búsqueda..." />
                  </CCol>
                  <div v-if="laboresIsSelected" class="ml-2 d-flex flex-column justify-content-end align-items-end w-100">
                    <div class="d-flex justify-content-end align-items-center">
                      <CButton
                        @click="show = true"
                        color="danger"
                        class="mr-1 sp-width-butom  d-flex align-items-center"
                      >
                        <CIcon class="mr-1" name="cil-list" />Cancelar Entregas
                      </CButton>
                    </div>
                    <label class="d-block text-right mt-2 mb-0">{{_countSelected_}} elementos selecciónados</label>
                  </div>
                </CRow>
              </template>

              <template #check-header>
                <div class="d-flex flex-row" v-if="items.length">
                  <input id="all" type="checkbox" @input="checkAll" :checked="_laboresCheck_" class="ml-3" />
                </div>
              </template>
              <template #check="{item}">
                <td class="py-2"><input v-model="laboresCheck[item.folio]" type="checkbox" class="form-check-input ml-3" /></td>
              </template>

              <template #folio-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Folio</span>
                  <OrderButtons :onClick="sortField" :field="'doc_entregas.folio'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #fechahora-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Fecha</span>
                  <OrderButtons :onClick="sortField" :field="'doc_entregas.payload->encabezado->fechahora'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #cliente_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Cliente</span>
                  <OrderButtons :onClick="sortField" :field="'cultivo.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #cultivo_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Cultivo</span>
                  <OrderButtons :onClick="sortField" :field="'cultivo.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #variedad-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Variedad</span>
                  <OrderButtons :onClick="sortField" :field="'cultivo.payload->variedad'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #embalaje-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Embalaje</span>
                  <OrderButtons :onClick="sortField" :field="'payload->encabezado->embalaje'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #calidad-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Calidad</span>
                  <OrderButtons :onClick="sortField" :field="'payload->encabezado->calidad'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #folio="{item}">
                <td class="py-2">{{ item.folio }}</td>
              </template>
              <template #fechahora="{item}">
                <td class="py-2">{{ getDate(item.payload.encabezado.fechahora) }}</td>
              </template>
              <template #estado="{item}">
                <td class="py-2">{{ item.estado }}</td>
              </template>
              <template #ubicaciones="{item}">
                <td class="py-2">{{ getUbicaciones(item.payload.encabezado.ubicaciones) }}</td>
              </template>
              <template #cliente_id="{item}">
                <!-- <td class="py-2">{{ getCultivo(item.payload.encabezado.cliente_id) }}</td> -->
                <td class="py-2">{{ item.payload.encabezado._relaciones.cliente?item.payload.encabezado._relaciones.cliente.payload.nombre:'' }}</td>
              </template>
              <template #cultivo_id="{item}">
                <!-- <td class="py-2">{{ getCultivo(item.payload.encabezado.cultivo_id) }}</td> -->
                <td class="py-2">{{ item.payload.encabezado._relaciones.cultivo.payload.nombre }}</td>
              </template>
              <template #variedad="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.cultivo.payload.variedad }}</td>
              </template>
              <template #embalaje="{item}">
                <td class="py-2">{{ item.payload.encabezado.embalaje }}</td>
              </template>
              <template #calidad="{item}">
                <td class="py-2">{{ item.payload.encabezado.calidad }}</td>
              </template>
              <template #cantidad="{item}">
                <td class="py-2">{{ item.payload.encabezado.cantidad }}</td>
              </template>
              <template #folio_factura="{item}">
                <td class="py-2">{{ item.payload.encabezado.folio_factura }}</td>
              </template>
              <template #cantidad_eq="{item}">
                <td class="py-2">{{ $formatter(`${item.payload.encabezado.cantidad_eq}`) }}</td>
              </template>
              <template #precio="{item}">
                <td v-if="item.payload.precio" class="py-2">{{ item.payload.precio.precio }}</td>
                <td v-else class="py-2">0</td>
              </template>
              <template #autor-header>
                <div class="d-flex flex-row">
                  <span v-show="mostrarColumnaAutor">Autor</span>
                </div>
              </template>
              <template #autor="{item}">
                <td class="py-2">
                  <span v-show="mostrarColumnaAutor">{{ item.author.correo }}</span>
                </td>
              </template>
              <template #hour-header>
                <div class="d-flex flex-row">
                  <span v-show="showHora">Hora</span>
                </div>
              </template>
              <template #hour="{item}">
                <td class="py-2">
                  <span v-show="showHora">{{ getHour(item.payload.encabezado.fechahora) }}</span>
                </td>
              </template>
              <template #created_at-header>
                <div class="d-flex flex-row">
                  <span v-show="showCratedAt">Fecha de creación</span>
                </div>
              </template>
              <template #created_at="{item}">
                <td class="py-2">
                  <span v-show="showCratedAt">{{ getFullDate(item.created_at) }}</span>
                </td>
              </template>
              <template #ver="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'VerEntrega',
                      params: {
                        id: item.folio,
                        config: {
                          page: page,
                          dates: selectedDate,
                          cultivo: cultivo,
                    ubicacion: ubicacion,
                          }
                      }
                    }"
                  >
                    <CButton color="success" square size="sm">Ver</CButton>
                  </router-link>
                </td>
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'EditEntrega',
                      params: {
                        folio: item.folio,
                        config: { page: page, dates: selectedDate }
                      }
                    }"
                  >
                    <CButton color="primary" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #price="{item, index}">
                <td class="py-2">
                  <CButton color="info" square size="sm" @click="togglePrice(index, item)">Precio</CButton>
                </td>
              </template>
              <template #reporte="{item, index}">
                <td class="py-2">
                  <CButton
                    color="info"
                    square
                    size="sm"
                    @click="getReporte(index, item)"
                  >
                  <i v-if="loader[index]" class="fa fa-spinner fa-pulse"></i>
                  <template v-else>PDF</template>
                  </CButton>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                  >Cancelar</CButton>
                </td>
              </template>
              <template #under-table>
                <div class="footer-table">
                  <div style="gap: 5px" class="d-flex align-items-center justify-content-start">
                    Total {{total}} ,
                    <CSelect
                    :value="limit"
                    label=""
                    invalidFeedback="Campo requerido, debe seleccionar una opción"
                    :options="[10,25,50,100]"
                    @update:value="v=>limit=v"
                    class="mb-0"
                    />{{" "}}artículos / página
                  </div>
                  <CPagination :activePage.sync="page" :pages="pages" align="center"
                    @update:activePage="e => actualizarInfo()" />
                </div>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      size="sm"
      title=""
      :centered="true"
      :no-close-on-backdrop="true"
      color="danger"
      :show.sync="show"
    >
      <template #header>
        <h5 class="modal-title">Cancelar entregas</h5>
        <CButtonClose @click="show = false" class="text-white" />
      </template>
      ¿Esta seguro que quiere cancelarlos?
      <template #footer>
          <CButton @click="show = false" color="danger">Cancelar</CButton>
          <CButton @click="cancelarDocs()" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="priceModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Asignar Precio"
      color="info"
    >
      <h4>Folio: {{ this.itemModal.name }}</h4>
      <CRow>
        <CCol>
          <CInput
            v-model="newPrice"
            append=".00"
            prepend="$"
            label="Precio:"
            placeholder="Precio.."
            type="number"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <label>Cliente:</label>
          <v-select
            v-model="cliente"
            :options="clientes"
            class="margin-multi"
            placeholder="Selecciona un cliente"
          >
            <template #open-indicator="{ attributes }">
              <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
            </template>
            <template #no-options>Sin resultados.</template>
          </v-select>

          <CRow>
            <CCol sm="12" md="12" lg="12">
              <CInput
                v-model="folio_factura"
                label="Folio Factura"
                placeholder="Folio Factura..."
                type="text"
              />
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Asignar precio</h5>
        <CButtonClose @click="priceModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="priceModal = false" color="danger">Cancelar</CButton>
        <CButton @click="updatePrice(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Cancelar Entrega"
      color="danger"
    >
      <h5 class="text-center">¿Deseas cancelar la entrega con folio {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Cancelar Entrega</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton @click="cancelDocto(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>

    <CModal
     :closeOnBackdrop="false"
      size="sm"
      :title="loadingModal||''"
      :centered="true"
      color="info"
      :show.sync="_loadingModal"
    >
      <template #footer>
        <strong></strong>
      </template>
      <div
        class="w-100 d-flex justify-content-center"
      >
        <div class="sk-flow align-items-center">
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
        </div>
      </div>
    </CModal>
  </div>
</template>

<script>
import DateSelector from "../../customComponents/DateSelector";
// import "v-calendar/lib/v-calendar.min.css";
import vSelect from "vue-select";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import OrderButtons from "../../customComponents/OrderButtons";
import GridAutorMixin from "../../mixins/GridAutor";
import { validationMixin } from "vuelidate";



const fields = [
  { key: "check", label: "", _style: "width: 40px" },
  { key: "folio", label: "Folio", _style: "width: 70px" },
  { key: "fechahora", label: "Fecha", _style: "min-width: 70px" },
  { key: "hour", label: "Hora", _style: "width:1%", },
  { key: "folio_factura", label: "Folio Factura", _style: "width:1%" },
  { key: "estado", label: "Estado", _style: "width:1%" },
  { key: "ubicaciones", label: "Ubicaciones", _style: "width:1%" },
  { key: "cliente_id", label: "Cliente", _style: "width:1%" },
  { key: "cultivo_id", label: "Cultivo", _style: "width:1%" },
  { key: "variedad", label: "Variedad", _style: "width:1%" },
  { key: "embalaje", label: "Embalaje", _style: "width:1%" },
  { key: "cantidad", label: "Cantidad", _style: "min-width:70px" },
  { key: "cantidad_eq", label: "Cantidad Equivalencia", _style: "min-width:70px" },
  { key: "precio", label: "Precio", _style: "min-width:70px" },
  {
    key: "autor",
    label: "",
    _style: "width:1%",
  },
  {
    key: "ver",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  // {
  //   key: "edit",
  //   label: "",
  //   _style: "width:1%",
  //   sorter: false,
  //   filter: false
  // },
  {
    key: "reporte",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "price",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];


export default {
  name: "Entrega",
  components: {
    DateSelector,
    vSelect,
    OrderButtons
  },
  mixins: [GridAutorMixin,validationMixin],
  validations: {
    query:{
      cantidad:{
        start:{
          maxValue: (v,cantidad)=>{
            return cantidad.start && cantidad.end ? Number(v) <= Number(cantidad.end) : true
          }
        },
        end:{
          minValue: (v,cantidad)=>{
            return cantidad.start && cantidad.end ? Number(v) >= Number(cantidad.start) : true
          }
        }
      }
    }
  },
  data() {
    return {
      limit: 10,
      total: 0,
      laboresCheck: {},
      loadingModal: '',
      query:{
        cantidad:{start:'',end:''},
      },
      showHora: false,
      showCratedAt: false,
      advanceFilter: false,
      show: false,

      items: [],
      fields,
      warningModal: false,
      error: "",
      isLoteActive: false,
      config: this.$route.params.config,
      color1: "primary",
      color2: "secondary",
      priceModal: false,
      cancelModal: false,
      isCreated: false,
      dropdownCustom: false,
      showCancel: false,
      itemModal: { id: "", name: "", index: "" },
      actualSort: "doc_entregas.payload->encabezado->fechahora",
      actualSortJoin: "",
      ubicaciones: [],
      ubicacionesAll: [],
      cultivos: [],
      variedades: [],
      filter: "",
      showUbicaciones: false,
      cultivosAll: [],
      lotes: [],
      isLoading: false,
      isLoadingInfo: false,
      clientes: [],
      cliente: null,
      folio_factura: null,
      newPrice: 0,
      page: 1,
      pages: 1,
      sorting: "desc",
      sortingJoin: "",
      cambioUbicacionRaiz: false,
      sort: [
        {
          field: "doc_entregas.folio",
          isSorter: true
        },
        {
          field: "doc_entregas.payload->encabezado->fechahora",
          isSorter: true
        }
      ],
      priceChange: 0,
      cultivo: null,
      variedad: null,
      ubicacion: null,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      lote: null,
      selectedDate: {
        start: moment()
          .startOf("month")
          .toDate(),

        end: moment()
          .endOf("month")
          .toDate()
      },
      loader:{},
    };
  },

  created() {
    if (this.ubicacionRaiz == "") {
      this.items = []
      this.ubicaciones = []
      this.cultivos = []
      return
    }
    this.isCreated = false;
    this.page = this.config ? this.config.page : 1;
    this.cultivo = this.config && this.config.cultivo;
    this.ubicacion = this.config && this.config.ubicacion;
    this.selectedDate = this.config ? this.config.dates : this.selectedDate;
    this.actualizarInfo(true);
    this.$store.dispatch("customHTTP", { schema: "clientes" })
    .then(clientes=>{
      this.clientes = clientes.data.map(cliente => {
        return { value: cliente.id, label: `${cliente.payload.nombre}`};
      });
    })
  },

  computed: {
    query_filter(){
      return Object.keys(this.query).reduce((v,key)=>{
        if(key==='comentarios'){
          this.query.comentarios&&
          v.push({
            field: "doc_entregas.payload->encabezado->comentarios",
            operator: "like",
            value: `%${this.query.comentarios}%`,
            collate: "utf8mb4_unicode_ci"
          })
        }
        if(key==='cantidad'){
          this.query.cantidad.start&&
          v.push({
            field: "doc_entregas.payload->encabezado->cantidad",
            operator: ">=",
            value: Number(this.query.cantidad.start),
          })
          this.query.cantidad.end&&
          v.push({
            field: "doc_entregas.payload->encabezado->cantidad",
            operator: "<=",
            value: Number(this.query.cantidad.end),
          })
        }
        return v
      },[])
    },
    query_cantidad_start(){
      return this.$v.query.cantidad.start.$dirty?!this.$v.query.cantidad.start.$invalid:null
    },
    query_cantidad_end(){
      return this.$v.query.cantidad.end.$dirty?!this.$v.query.cantidad.end.$invalid:null
    },
    _loadingModal:{
      get(){
        return !!this.loadingModal
      },
      set(val){
        this.loadingModal = val||''
      }
    },
    _countSelected_(){
      return Object.keys(this.laboresCheck).reduce((v,key)=>this.laboresCheck[key]?v+1:v,0)
    },
    _laboresCheck_(){
      return Object.keys(this.laboresCheck).length&&this.items.map(m=>m.folio).every(key=>this.laboresCheck[key])
    },
    docsLaboresCancel_(){
      return this.laboresCheck_.map(m=>({
        folio: m,
        serie: "",
        schema: "entregas"
      }))
    },
    laboresIsSelected(){
      return Object.keys(this.laboresCheck).some(s=>this.laboresCheck[s])
    },
    laboresCheck_(){
      return Object.keys(this.laboresCheck).filter(ff=>this.laboresCheck[ff])
    },
    rangeStart() {
      return new Date(this.selectedDate.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.selectedDate.end).toLocaleDateString();
    },
    filteredItems() {
      return this.items.filter(
        i =>
          i.folio
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getDate(i.payload.encabezado.fechahora)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getUbicacion(i.payload.encabezado.ubicacion_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getCliente(i.payload.encabezado.cliente_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getCultivo(i.payload.encabezado.cultivo_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          i.payload.encabezado.embalaje
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          i.payload.encabezado.calidad
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          i.payload.encabezado.cantidad
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          i.payload.encabezado.cantidad_eq
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase())
      );
    },
    headersTable() {
      return this.fields.filter(ff=>{
        if(
          (ff.key==='ubicaciones'&&!this.showUbicaciones) ||
          (ff.key==='hour'&&!this.showHora) ||
          (ff.key==='created_at'&&!this.showCratedAt) ||
          (ff.key==='autor'&&!this.mostrarColumnaAutor)
        ){
          return false
        }
        return true
      })
    },
    variedadesPorCultivo() {
      const cultivo = this.cultivo
      return cultivo === undefined || cultivo === null ? [] : this.variedades.filter(variedad => {
        return cultivo.label === variedad.cultivo
      });
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    limit() {
      this.actualizarInfo()
    },
    items(newV,){
      this.loader = newV.reduce((v,c,i)=>({...v,[i]:false}),{})
      Object.keys(this.laboresCheck).forEach(key=>{
        if (!newV.find(f=>f.folio === Number(key))) {
          delete this.laboresCheck[key];
        }
      })
    },
    ubicacionRaiz: function() {
      if (this.ubicacionRaiz == "") {
        this.items = []
        this.ubicaciones = []
        this.cultivos = []
        return
      }
      this.cambioUbicacionRaiz = true
      this.page = 1;
      this.actualizarInfo(true);
    }
  },

  methods: {

    validForm(){
      this.$v.$reset();
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.actualizarInfo()
      }
    },
    cancelarDocs(){
      this.show = false
      this.isLoading = true
      this.isLoading = false

      this.loadingModal =  "Cancelando..."
      this.$store.dispatch("customDocumentoCancelHTTP",this.docsLaboresCancel_)
          .then(()=>{
            this.actualizarInfo()
          })
          .catch(rej => {
            console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.editModal = false
            this.edit = {}
            this.isLoading = false
            this.loadingModal = ''
            this.laboresCheck = {}
          })
    },
    checkAll(e){
        this.laboresCheck = this.items.reduce((v,c)=>{
          v[c.folio] = e.target.checked
          return v
        },{})

    },
    toggleHora() {
      this.showHora = !this.showHora;
    },
    toggleCreatedAt() {
      this.showCratedAt = !this.showCratedAt;
    },
    toggleAdvanceFilter() {
      this.advanceFilter = !this.advanceFilter;
    },
    getHour(date) {
      if(date === undefined || date === '') {
        return 'N/A';
      }
      let newDate = moment(date);
      return newDate.format("HH:mm:ss");
    },
    getReporte(index,item){
      if(this.loader[index]){
        return
      }
      this.loader[index] = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_entregas",
        params: { folio:item.folio, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);


        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de entregas.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader[index] = false
          this.$forceUpdate();
        });
    },
    toggleUbicaciones() {
      // console.log("entro");
      this.showUbicaciones = !this.showUbicaciones;
    },
    toggleShowCancel() {
      // console.log("entro");
      this.showCancel = !this.showCancel;
      this.actualizarInfo();
    },
    searchTimeOut() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          // console.log("funciona");
          this.actualizarInfo();
        }, 800);
      }
    },
    getCliente(cliente_id) {
      console.log(cliente_id,'Cliente')
      const clienteActual = this.clienteAll.filter(
        cliente => cliente.id == cliente_id
      );
      if (clienteActual.length > 0) {
        const variedad = clienteActual[0].payload.variedad || ''
        return `${clienteActual[0].payload.nombre} ${variedad}`;
      } else {
        return "";
      }
    },
    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivosAll.filter(
        cultivo => cultivo.id == cultivo_id
      );

      if (cultivoActual.length > 0) {
        const variedad = cultivoActual[0].payload.variedad || ''
        return `${cultivoActual[0].payload.nombre} ${variedad}`;
      } else {
        return "";
      }
    },
    getUbicacion(ubicacion_id) {
      const ubicacionActual = this.ubicacionesAll.filter(
        ubicacion => ubicacion.id == ubicacion_id
      );

      if (ubicacionActual.length > 0) {
        return ubicacionActual[0].payload.nombre;
      } else {
        return "";
      }
    },
    sortField(field, direction, join) {
      if (join) {
        this.actualSort = ""
        this.sorting = ""
        this.actualSortJoin = field
        this.sortingJoin = direction
      }else{
        this.actualSort = field
        this.sorting = direction
        this.actualSortJoin = ""
        this.sortingJoin = ""
      }
      this.actualizarInfo();
    },
    getSorted(field) {
      const newSort = this.sort.find(item => item.field == field);
      if (newSort) {
        return newSort.isSorter;
      }
      return false;
    },
    dateSelection() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.actualizarInfo();
        }, 800);
      }
    },
    getDate(date) {
      if(date === undefined || date === '') {
        return 'N/A';
      }
      let newDate = moment(date,"YYYY-MM-DD 00:00:00");
      return newDate.format("DD/MM/YYYY");
    },
    getFullDate(date) {
      if(date === undefined || date === '') {
        return 'N/A';
      }
      let newDate = moment(date);
      return newDate.format("DD/MM/YYYY HH:mm:ss");
    },
    toggleLote() {
      this.isLoteActive = !this.isLoteActive;
      this.color1 = this.isLoteActive ? "primary" : "secondary";
      this.color2 = this.isLoteActive ? "secondary" : "primary";
      this.isLoteActive
        ? ((this.cultivo = null), (this.ubicacion = null))
        : (this.lote = null);
      this.filterLotes();
    },
    filterLotes() {
      if(this.advanceFilter){
        return
      }
      this.actualizarInfo()
    },
    limpiarVariedad() {
      this.variedad = null
    },
    toggleEdit(index, item) {
      this.modal = true;
      const itemIndex = {
        id: index,
        name: item.cultivo
      };
      this.itemModal = itemIndex;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
    },
    togglePrice(index, item) {
      this.priceModal = true;
      this.newPrice = item.payload.precio ? item.payload.precio.precio : 0;
      this.folio_factura = item.payload.encabezado.folio_factura;
      this.cliente = item.payload.encabezado.cliente_id?{value: item.payload.encabezado.cliente_id, label: item.payload.encabezado._relaciones.cliente.payload.nombre}:null
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
      console.log(this.itemModal);
    },
    cancelDocto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: "entregas",
          folio: id
        })
        .then(() => {
          // console.log(res.data);
          // const index = this.items.findIndex(item => item.folio == id);
          // this.items[index].estado = "cancelado";
          this.actualizarInfo();
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          // if (index !== -1) {
          //   this.items.splice(index, 1);
          // }
          this.cancelModal = false;
        });
    },
    updatePrice(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customDocumentoActualizarHTTP", {
          schema: "entregas",
          folio: id,
          payload: {
            precio: {
              precio: Number(this.newPrice),
            },
            encabezado:{
              cliente_id: this.cliente ? this.cliente.value : 0,
              ...this.folio_factura ?{folio_factura: this.folio_factura }:{},
            }
          }
        })
        .then(() => {
          this.priceModal = false;
          this.actualizarInfo();

          // console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })
        .finally(() => {
          //  if (index !== -1) {
          //    this.items[index].payload.precio.precio = this.newPrice;
          //  }
          this.isLoading = false;
          this.priceModal = false;
        });
    },
    getUbicaciones(ubicaciones) {
      let nombreUbicaciones = "";
      let ubicacionActual;

      ubicaciones.forEach(element => {
        // console.log(element);
        // console.log(this.ubicacionesAll);
        ubicacionActual = this.ubicacionesAll.find(
          ubicacion => ubicacion.id == element
        );
        // console.log(ubicacionActual);
        // console.log(ubicacionActual);
        if (ubicacionActual) {
          nombreUbicaciones = `${nombreUbicaciones}${ubicacionActual.payload.nombre}, `;
        }
      });
      let nombreUbicacionesLast = nombreUbicaciones.slice(0, -2);
      return nombreUbicacionesLast;
    },
    actualizarInfo(flagCombos = false){
      this.$v.$reset();
      if (this.ubicacionRaiz == "") {
        this.items = []
        return
      }

      this.isLoading = true;

      let template = {
        schema: "entregas",
        limit: this.limit,
        page: this.page,
        filter: {
          wherein: [{
            field: "doc_entregas.payload->encabezado->ubicacion_raiz_id",
            value: [this.ubicacionRaiz]
          }],
          where: [
            {
              field: "doc_entregas.payload->encabezado->fechahora",
              operator: ">=",
              value: moment(this.selectedDate.start).format("YYYY-MM-DD 00:00:00")
            },
            {
              field: "doc_entregas.payload->encabezado->fechahora",
              operator: "<=",
              value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
            }
          ]
        },
        ["with-storage"]: ["*"]
      };

      this.actualSort != "" ? (template = {
        ...template,
        order: [{
          field: this.actualSort,
          direction: this.sorting
        }]
      }) : null

      this.actualSortJoin != "" ? (template = {
        ...template,
        orderByJoin: [{
          field: this.actualSortJoin,
          direction: this.sortingJoin
        }]
      }) : null

      !this.advanceFilter && this.filter != "" ? (template = {
        ...template, filter: {
          ...template.filter,
          and: {
            orWhere: [
              {
                field: "doc_entregas.folio",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "doc_entregas.payload->encabezado->embalaje",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "doc_entregas.payload->encabezado->calidad",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "doc_entregas.payload->encabezado->cantidad",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "doc_entregas.payload->encabezado->cantidad_eq",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "doc_entregas.payload->precio->precio",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ...this.mostrarColumnaAutor?[
              {
                field: "doc_entregas.author->correo",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[],
            ],
            orWhereJoin: [
              {
                field: "cultivo.payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "cultivo.payload->variedad",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "cliente.payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
            ]
          }
        }
      }) : null;

      this.cultivo != null ? (template = {
        ...template,
        filter: {
          ...template.filter,
          whereJoin: [
            {
              field: "cultivo.payload->nombre",
              operator: "=",
              value: this.cultivo.label
            }
          ]
        }
      }) : null

      this.variedad != null ? (template = {
        ...template,
        filter: {
          ...template.filter,
          whereJoin: [
            ...template.filter.whereJoin,
            {
              field: "cultivo.payload->variedad",
              operator: "=",
              value: this.variedad.label
            }
          ]
        }
      }) : null

      this.ubicacion != null ? (template = {
        ...template,
        filter: {
          ...template.filter,
          where: [
            ...template.filter.where,
            {
              field: "doc_entregas.payload->encabezado->ubicaciones",
              operator: "regexp",
              value: `[[:<:]]${this.ubicacion.value}[[:>:]]`
            }
          ]
        }
      }) : null

      if(this.advanceFilter&&(this.query_filter.length>0)){
        template.filter.and = {
          ...this.query_filter.length?{where: this.query_filter}:{}
        }
      }

      !this.showCancel ? (template = {
        ...template, filter: {
          ...template.filter,
          where: [
            ...template.filter.where,
            {
              field: "doc_entregas.estado",
              operator: "!=",
              value: "cancelado"
            }
          ]
        }
      }) : null;

      const documento = [
        this.$store.dispatch("customDocumentoHTTP", template)
      ]

      if (flagCombos || !this.isCreated || this.cambioUbicacionRaiz) {
        this.cambioUbicacionRaiz = false
        this.isLoadingInfo = true
        documento.push(this.$store.dispatch('customHTTP', {
          schema: 'configuracion',
          filter: {
            where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
          }
        }))
        documento.push(this.$store.dispatch("customHTTP", { schema: "cultivos" }))
        documento.push(this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
            filter: {
              where: [
                {
                  field: "payload->raiz_id",
                  operator: "=",
                  value: this.ubicacionRaiz
                },
                {
                  field: "payload->suspendido",
                  operator: "=",
                  value: false
                }
              ]
            },
            order:[{
              field: 'payload->nombre',
              direction: 'asc'
            }]
          })
        )
      }

      Promise.all(documento)
        .then(([balances, configuracion, cultivos, ubicaciones]) => {
          this.items = balances.data;
          this.total = balances?.paginate?.total||0
          this.pages = balances.paginate.last_page;
          this.page = balances.paginate.current_page;
          if (configuracion&&configuracion.data.length>0) {
            this.cultivos = configuracion.data[0].payload.valor.map((cultivo, ) => {
              return {label: cultivo.nombre}
            })
          }
          if (cultivos&&cultivos.data.length>0) {
            this.variedades = cultivos.data.map(cultivo => {
              return { value: cultivo.id, label: cultivo.payload.variedad, cultivo: cultivo.payload.nombre};
            }).filter(variedad => {
              return variedad.label != undefined
            });
            this.cultivosAll = cultivos.data;
          }
          if (ubicaciones&&ubicaciones.data.length>0) {
            this.ubicaciones = ubicaciones.data.map(ubicacion => {
              return { value: ubicacion.id, label: ubicacion.payload.nombre };
            });
            this.ubicacionesAll = ubicaciones.data;
          }
          this.isCreated = true;
        })
        .finally(() => {
          this.isLoading = false
          this.isLoadingInfo = false
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

  .footer-table{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .dropdown-menu{
    min-width: 14rem;
  }
  .advance-filter .multiselect__spinner{
    height: 30px;
  }
  .advance-filter .multiselect__placeholder{
    margin-bottom: 0px;
  }
  .advance-filter .multiselect__select{
    height: 34px;
  }
  .advance-filter .multiselect__tags{
      max-height: 35px;
      overflow: auto;
      min-height: unset;
      padding: 5px 40px 5px 5px;
  }
  .advance-filter .multiselect__content-wrapper{
      width: 100%;
  }
  .advance-filter .vs__dropdown-toggle{
      height: 35px;
  }
</style>


<style scoped>
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.padding-left-custom {
  padding-right: 5rem;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
